module.exports = __webpack_public_path__ + "media/SP-mini.2e4ed87e.mp4";